import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './RegistrationClosed.css';

const RegistrationClosed: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <div className="registration-closed-container">
      <div className="registration-closed-card">
        <div className="stop-sign">
          <div className="stop-sign-inner">
            <div className="stop-sign-text">Stop</div>
          </div>
        </div>
        <h1>Registration is Currently Closed</h1>
        <p>We are not accepting registrations at this time. Please check back later.</p>
        <button onClick={handleLogout} className="logout-button">
          Logout
        </button>
      </div>
    </div>
  );
};

export default RegistrationClosed; 